import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lottie"]

  connect() {
    this.hideLoader()
    this.setupTurboListeners()
  }

  setupTurboListeners() {
    this.boundShowLoader = this.showLoader.bind(this)
    this.boundHideLoader = this.hideLoader.bind(this)

    document.addEventListener("turbo:submit-start", this.boundShowLoader)
    document.addEventListener("turbo:submit-end", this.boundHideLoader)
    // Associate modal opens via turbo-stream link → synthetic hidden form; ensure overlay clears.
    document.addEventListener("turbo:before-stream-render", this.boundHideLoader)
    document.addEventListener("turbo:stream-render", this.boundHideLoader)
    document.addEventListener("turbo:fetch-request-error", this.boundHideLoader)
  }

  disconnect() {
    document.removeEventListener("turbo:submit-start", this.boundShowLoader)
    document.removeEventListener("turbo:submit-end", this.boundHideLoader)
    document.removeEventListener("turbo:before-stream-render", this.boundHideLoader)
    document.removeEventListener("turbo:stream-render", this.boundHideLoader)
    document.removeEventListener("turbo:fetch-request-error", this.boundHideLoader)
  }

  showLoader(event) {
    // Turbo turns data-turbo-stream links into temporary hidden forms (associate modal open).
    // Those are GET/stream requests — no full-page loader; submit-end may not always fire.
    // Called without an event from file-upload and other controllers — always show then.
    if (event?.target && this.isTurboStreamLinkForm(event.target)) return

    this.element.classList.remove("d-none")
  }

  hideLoader() {
    this.element.classList.add("d-none")
  }

  isTurboStreamLinkForm(target) {
    return target instanceof HTMLFormElement
      && target.hasAttribute("hidden")
      && target.hasAttribute("data-turbo-stream")
  }

}